import { GetBaseUrl } from '@/utils/ConfigHelper'
import axios from "axios";
import Response from '@/utils/Videomonster/Common/Response'


/**
 * @param {String} token
 * @param {{
 *      mallId
 *      cfrefreshtoken
 * }} data
 * @throws {Error}
 * @returns {Promise<Response>}
 */
const UpdateCafe24RefreshToken = async (token, data = {}) => {
    try {
        const url = `${GetBaseUrl()}/api/auth/cafe24-refresh-token`;
        const body = { ...data }
        const response = await axios.post(url, body, { Authorization: `Bearer ${token}` });

        const result = (response.status === 200);
        const resultData = response.data.data;

        return new Response(result, resultData)
    } catch (e) {
        throw e;
    }
}

/**
 * @param {String} token
 * @param {{
 *      activatePermanently
 * }} data
 * @throws {Error}
 * @returns {Promise<Response>}
 */
const PostRequiredBoxAgreement = async (token, data = {}) => {
    try {
        const url = `${GetBaseUrl()}/api/auth/agreement`
        const config = { Authorization: `Bearer ${token}` }
        const response = await axios.post(url, data, { headers: config })
        const result = (response.status === 200)

        return new Response(result, response)
    } catch (e) {
        throw e
    }
}

export default {
    UpdateCafe24RefreshToken,
    PostRequiredBoxAgreement
}